import React, { Component } from 'react';
import b from 'b_';

import { NewsStub } from '@components/news-widget';
import { BannerStub } from '@components/banner';
import { ThemesStub } from '@components/themes-widget';
import PublicationItemStub from '@components/publication-item/publication-item.stub';
import { ResearchersStub } from '@components/researchers';
import Rect from '@components/rect';

const class_ = b.with('home-page-stub');

export default class HomePageStub extends Component {
    public shouldComponentUpdate() {
        return true;
    }

    public render() {
        return (
            <div className={class_()}>
                <div className="block centering">
                    <BannerStub />
                </div>
                <div className="block centering">
                    <div className="block__head">
                        <Rect width={150} height={48} type="black" />
                        <span className="block__title-link">
                            <Rect width={100} height={24} />
                        </span>
                    </div>
                    <NewsStub itemsCount={3} type="horizontal" />
                </div>
                <div className="block centering">
                    <div className="block__head">
                        <Rect width={250} height={48} type="black" />
                    </div>
                    <ThemesStub itemsCount={6} />
                </div>
                <div className="block centering">
                    <div className="block__head">
                        <Rect width={200} height={48} type="black" />
                        <span className="block__title-link">
                            <Rect width={100} height={24} />
                        </span>
                    </div>
                    <PublicationItemStub
                        type="vertical"
                        itemsCount={3}
                    />
                </div>
                <div className="block centering">
                    <div className="block__head">
                        <Rect width={180} height={48} type="black" />
                        <span className="block__title-link">
                            <Rect width={100} height={24} />
                        </span>
                    </div>
                    <ResearchersStub itemsCount={6} />
                </div>
            </div>
        );
    }
}
